// 获取随机6位字符串
function getRandomString(length) {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length))
  }
  return result
}
// 获取时间
function getUTCTimestampInSeconds() {
  const now = new Date() // 获取当前时间
  const utcTimestampInMilliseconds = now.getTime() // 获取当前时间的毫秒时间戳
  const utcTimestampInSeconds = Math.floor(utcTimestampInMilliseconds / 1000) // 转换为秒
  return utcTimestampInSeconds
}
export default {
  getRandomString,
  getUTCTimestampInSeconds
}
